import { useState, useRef } from 'react';
import useIsMobile from '../Layout/useIsMobile';

import './Accordion.scss';

export const Accordion = ({ accordionName, children, content, label }) => {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile && (
        <div className="accordion">
          <input
            checked={open}
            className="accordion--input"
            id={accordionName}
            onChange={() => setOpen(!open)}
            type="checkbox"
          />
          <label className="accordion--label" htmlFor={accordionName}>
            {label}
            <img alt="Chevron icon" className="accordion--chevron-icon" src="/images/icon-chevron-down.svg" />
          </label>

          <div
            className="accordion--content"
            ref={contentRef}
            style={{
              maxHeight: open ? `${contentRef.current.scrollHeight}px` : '0px'
            }}
          >
            <hr className="accordion--separator" />
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      )}

      {!isMobile && children}
    </>
  )
};

export default Accordion;